import RequestService from "@/services/request.service";
import { AppError } from "@/services/error.service";
import { clone } from "@/plugins/query";

const UsersService = {
  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Organization%20Users/List%20Organization%20Users
  getAll: async function (organizationId, filters) {
    try {
      const path = `/api/v1/organizations/${organizationId}/users/`;
      return await RequestService.get(path, filters);
    } catch (error) {
      throw new AppError(error);
    }
  },

  get: async function (organizationId, userId) {
    try {
      const path = `/api/v1/organizations/${organizationId}/users/${userId}/`;
      return await RequestService.get(path);
    } catch (error) {
      throw new AppError(error);
    }
  },

  _prepareUser: function (data) {
    const payload = clone(data);
    payload.events = RequestService.replaceWithIds(data.events);
    return payload;
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Organization%20Users/Create%20Organization%20User
  create: async function (organizationId, data) {
    try {
      const path = `/api/v1/organizations/${organizationId}/users/`;
      return await RequestService.post(path, this._prepareUser(data));
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Organization%20Users/Update%20Organization%20User
  update: async function (organizationId, data) {
    try {
      const path = `/api/v1/organizations/${organizationId}/users/${data.id}/`;
      return await RequestService.put(path, this._prepareUser(data));
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Organization%20Users/v1_organizations_users_destroy
  delete: async function (organizationId, userId) {
    try {
      const path = `/api/v1/organizations/${organizationId}/users/${userId}/`;
      return await RequestService.delete(path);
    } catch (error) {
      throw new AppError(error);
    }
  },
};

export default UsersService;
